module.exports = __webpack_public_path__ + "static/media/mpc-benefits-mobile-comp.1d90e315.png";